export { default } from './halyk-bank';
